// Dependencies
import React from 'react';
import { useSubmit } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

// Styles
import {
  ContainerForm,
  ContainerOra,
  OraLogo,
  ArrowBackLink,
  Title,
  TextInput,
  Infotext,
  SubmitButton,
  LinkPolicy,
} from './styles';

import LogoOra from '../../../assets/logo.svg';
import LeftArrow from '../../../assets/icons/arrow-left.svg';

// Components
import { Typography } from '../../display/Typography';

// Schemas
import { ForgotPasswordFormSchema } from './schema';

// Types
import { ForgotPasswordFormType } from './types';

// Utils
import { createFormDataFromValues } from '../../../utils/forms';

// Media
import { useIsLandscapeTablet } from '../../../hooks/useMediaBreakPoints';

export default function ForgotPasswordForm() {
  const { t } = useTranslation('auth');
  const isLandscapeTablet = useIsLandscapeTablet();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<ForgotPasswordFormType>({
    mode: 'onTouched',
    reValidateMode: 'onBlur',
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(ForgotPasswordFormSchema) as any,
  });

  const submit = useSubmit();

  const onFormSubmit = (values: ForgotPasswordFormType) => {
    const formData = createFormDataFromValues(values);

    submit(formData, {
      method: 'post',
      action: '/forgot-password',
    });
  };

  return (
    <>
      <ContainerOra>
        <ArrowBackLink to={'/login'}>
          <img src={LeftArrow} alt={t('common:labels.goBack')} />
        </ArrowBackLink>
        <OraLogo src={LogoOra} alt={t('auth:login.roisLogo')} />
      </ContainerOra>
      <ContainerForm onSubmit={handleSubmit(onFormSubmit)}>
        <Title size="XL" variant="semiBold">
          {t('forgotPassword.title')}
        </Title>

        <TextInput
          {...register('email')}
          label={t('login.email')}
          labelSize={isLandscapeTablet ? 'XS' : 'S'}
          typeInput="email"
          type="email"
          placeholder={t('forms:placeholders.email')}
          autoComplete="email"
          error={errors.email?.message}
        />

        <Infotext size="S">{t('forgotPassword.instructions')}</Infotext>

        <SubmitButton
          type="submit"
          text={t('forgotPassword.sendButton')}
          disabled={false}
        />

        <LinkPolicy to={'#'}>
          <Typography size={isLandscapeTablet ? 'XXXS' : 'XS'}>
            {t('login.acceptingTerms')} <b>{t('login.privacyPolicy')}</b>
          </Typography>
        </LinkPolicy>
      </ContainerForm>
    </>
  );
}
